module.exports = __webpack_public_path__ + "img/munster.57ec3839.png";